import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;

    @supports (padding-bottom: var(--sab)) {
        overflow-y: auto;
        min-height: calc(100vh - var(--sab, 0px));
        max-height: calc(100vh - var(--sab, 0px));
    }
`;

export const Main = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ShuttleAppName = styled.div({
    display: "none",
});
